// extracted by mini-css-extract-plugin
export default {"wrapper":"AppAlertModal_wrapper__CG5Ov","item":"AppAlertModal_item__rdSJA","separator":"AppAlertModal_separator__T95UY"};